import { render, staticRenderFns } from "./sgh-tooltip.vue?vue&type=template&id=e35d5442&scoped=true"
import script from "./sgh-tooltip.vue?vue&type=script&lang=js"
export * from "./sgh-tooltip.vue?vue&type=script&lang=js"
import style0 from "./sgh-tooltip.vue?vue&type=style&index=0&id=e35d5442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e35d5442",
  null
  
)

export default component.exports